import { useState } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer/Footer';
import TrainingTable from '../../../components/Tables/Warren/Training';

import { SINavbar } from '../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';

const WarrenAppendix = () => {
	// modal state
	const [modal, setModal] = useState({
		title: '',
		description: '',
	});

	// modal handlers
	const [showModal, setShowModal] = useState(false);
	const handleShowModal = (title, image, description) => {
		setModal({ title: title, image: image, description: description });
		setShowModal(true);
	};

	return (
		<>
			<Header plant="warren" />
			<main>
				<wrapper class="section-wrapper">
					<SINavbar plant="warren" home />
					<container class="section-container" style={{}}>
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Training Documents</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content" style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div class="d-flex">
								<TrainingTable />
							</div>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAppendix;
